var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhSites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0H33C39.0751 0 44 4.92487 44 11V33C44 39.0751 39.0751 44 33 44H11C4.92487 44 0 39.0751 0 33V11Z",
    fill: "#EDFAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 29.6396V15.8896C17.417 15.4844 17.578 15.0958 17.8645 14.8093C18.151 14.5228 18.5396 14.3618 18.9448 14.3618H25.0559C25.4611 14.3618 25.8497 14.5228 26.1362 14.8093C26.4227 15.0958 26.5837 15.4844 26.5837 15.8896V29.6396H17.417Z",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4169 22.0004H15.8891C15.4839 22.0004 15.0953 22.1613 14.8088 22.4478C14.5223 22.7344 14.3613 23.123 14.3613 23.5281V28.1115C14.3613 28.5167 14.5223 28.9053 14.8088 29.1918C15.0953 29.4783 15.4839 29.6393 15.8891 29.6393H17.4169",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5835 19.7087H28.1113C28.5165 19.7087 28.9051 19.8697 29.1916 20.1562C29.4781 20.4427 29.6391 20.8313 29.6391 21.2365V28.1115C29.6391 28.5167 29.4781 28.9053 29.1916 29.1918C28.9051 29.4783 28.5165 29.6393 28.1113 29.6393H26.5835",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 17.417H23.5277",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 20.4723H23.5277",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 23.5284H23.5277",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 26.5837H23.5277",
    stroke: "#00A651",
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhSites);
export default __webpack_public_path__ + "static/media/AH-sites.ef2b5da474bfb1d47d50b09dfea8054a.svg";
export { ForwardRef as ReactComponent };